import React from 'react';
import { motion } from 'framer-motion';
import { FiExternalLink } from 'react-icons/fi';
import { certifications } from '../../data/portfolioData';
import CardSpotlight from '../CardSpotlight/CardSpotlight';
import styles from './Certifications.module.css';

const fadeUpVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
};

const staggerContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1 } }
};

const Certifications = () => {
  return (
    <section id="certifications" className={styles.certificationsSection}>
      <div className={styles.container}>
        <motion.div 
          className={styles.sectionHeader}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUpVariants}
        >
          <h2 className={styles.title}>Licenses & Certifications</h2>
          <div className={styles.line}></div>
        </motion.div>

        <motion.div 
          className={styles.grid}
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {certifications.map((cert, index) => (
            <motion.div 
              key={index} 
              className={styles.card}
              variants={fadeUpVariants}
              whileHover={{ y: -8, transition: { duration: 0.2, delay: 0 } }}
            >
              <CardSpotlight style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <div className={styles.cardContent}>
                  <div className={styles.issuer}>{cert.issuer}</div>
                  <h3 className={styles.certTitle}>{cert.title}</h3>
                  <div className={styles.date}>{cert.date}</div>
                  
                  <div className={styles.actions}>
                    <a 
                      href={cert.url} 
                      target="_blank" 
                      rel="noreferrer" 
                      className={styles.btnLink}
                    >
                      View <FiExternalLink size={16} />
                    </a>
                  </div>
                </div>
              </CardSpotlight>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Certifications;
